import React from 'react';

export const Dialog = ({ open, onOpenChange, children }) => {
    if (!open) return null;
  
    const handleOverlayClick = () => onOpenChange(false);
    const stopPropagation = (e) => e.stopPropagation();
  
    return (
      <div
        onClick={handleOverlayClick}
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div
          onClick={stopPropagation}
          className="bg-white text-black rounded-lg p-6 w-full max-w-2xl relative shadow-lg"
        >
          <button
            onClick={() => onOpenChange(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-black"
          >
            ✕
          </button>
          {children}
        </div>
      </div>
    );
  };
  
  export const DialogContent = ({ children, className = '' }) => (
    <div className={`mt-2 ${className}`}>{children}</div>
  );
  
  export const DialogHeader = ({ children }) => (
    <div className="mb-4">{children}</div>
  );
  
  export const DialogTitle = ({ children }) => (
    <h2 className="text-xl font-bold">{children}</h2>
  );
  
  export const DialogTrigger = ({ asChild = false, onClick, children }) => {
    if (asChild && React.isValidElement(children)) {
      return React.cloneElement(children, {
        onClick: (e) => {
          children.props?.onClick?.(e);
          onClick?.(e);
        },
      });
    }
  
    return (
      <button
        onClick={onClick}
        className="bg-mentixxgreen text-black px-4 py-2 rounded"
      >
        {children}
      </button>
    );
  };
  